// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import elementResizeDetector from 'element-resize-detector';
import cx from 'classnames';
import MenuItem from './menu-item';
import Tether from './tether';
import withShow from './show';
import { OrgLinks } from '../global-nav/global-nav-org';

class Menu extends React.Component {
  static propTypes = {
    style: PropTypes.instanceOf(Object),
    className: PropTypes.string,
    useDefaultStyles: PropTypes.bool,
    isOrgMenu: PropTypes.bool,
    title: PropTypes.string,
    onHide: PropTypes.func,
    renderItems: PropTypes.func,
    items: PropTypes.instanceOf(Array),
    horizontalOffset: PropTypes.number,
    verticalOffset: PropTypes.number,
    horizontalAlignment: PropTypes.oneOf(['center', 'left', 'right']),
    allowAbove: PropTypes.bool,
    minWidth: PropTypes.number,
    maxWidth: PropTypes.number,
    tetherProps: PropTypes.object,
    hidden: PropTypes.bool,
  };

  static defaultProps = {
    useDefaultStyles: true,
    horizontalOffset: 0,
    verticalOffset: 0,
    maxWidth: Number.MAX_SAFE_INTEGER,
    minWidth: 0,
  };

  constructor(props) {
    super(props);

    this.state = {
      metrics: {},
    };

    this._sizeDetector = elementResizeDetector();
  }

  componentDidMount() {
    this.addEvents();
  }

  componentWillUnmount() {
    this.removeEvents();
  }

  render() {
    const { styles } = Menu;

    const classes = css(styles.container,
      this.props.className,
      this.props.css,
      this.props.useDefaultStyles && styles.visualStyles);

    return (
      <Tether
        show
        onPositionChange={this.handlePositionChange}
        desiredHeight={this.desiredHeight}
        desiredWidth={this.desiredWidth}
        verticalOffset={this.props.verticalOffset}
        horizontalOffset={this.props.horizontalOffset}
        horizontalAlignment={this.props.horizontalAlignment}
        allowAbove={this.props.allowAbove}
        ref={this.bindTether}
        {...this.props.tetherProps}
      >
        {({ minWidth, maxWidth, maxHeight }) => (
          <div
            className={classes}
            ref={this.bindContainer}
            style={{ minWidth: Math.max(minWidth, this.props.minWidth), maxWidth: Math.min(maxWidth, this.props.maxWidth), maxHeight }}
          >
            <div
              style={this.props.style}
              ref={this.bindContent}
            >
              {this.props.title && (<div className={cx(styles.menuTitle, styles.menuItem, 'subheading')}>{this.props.title}</div>)}
              {this.renderItems()}
              {this.props.isOrgMenu && <OrgLinks />}
            </div>
          </div>
        )}
      </Tether>
    );
  }

  desiredHeight = (tether) => {
    // the desired height of the menu is the height of the content
    if (this._content) {
      return this._content.offsetHeight;
    }

    return 0;
  };

  desiredWidth = (tether) => {
    // the desired height of the menu is the current width of the content
    if (this._content) {
      return this._content.offsetWidth;
    }

    return 0;
  };

  setCapture() {
    this._captured = true;
  }

  releaseCapture() {
    this._captured = false;
  }

  renderItems() {
    if (this.props.renderItems) {
      return this.props.renderItems(this);
    }

    return this.props.items.map((item, index) => {
      if (!item) {
        return null;
      }

      const handleClick = this.handler(item.onClick, item);

      if (item.renderContent) {
        return item.renderContent(item, index);
      }

      return (
        <React.Fragment key={index}>
          {!item.hidden && (
            <MenuItem
              onClick={handleClick}
              className={item.className}
              iconClass={item.icon}
              iconWidth={item.iconWidth}
              iconHeight={item.iconHeight}
              iconStyle={item.iconStyle}
              label={item.label}
              style={item.style}
              current={item.current}
            />
          )}
        </React.Fragment>
      );
    });
  }

  handler = (callback, item) => () => {
    this.hide();

    callback(item);
  };

  handleResize = () => {
    if (this._tether) {
      this._tether.position();
    }
  };

  handleWindowClick = (event) => {
    // if something captured input, don't hide the menu
    if (this._captured) {
      return;
    }

    const isDescendantOfMenu = this._tether && this._tether.containsDOMNode(event.target);

    // Hide the menu if the clicked node is outside the target *and* completely outside the menu popup. The
    // target element is the element that activates the menu.
    if (!isDescendantOfMenu
         && !this.isDescendantOfMagicElement(event.target)
         && this._tether
         && this._tether.targetDOMNode
         && this._tether.targetDOMNode.parentNode
         && !this._tether.targetDOMNode.parentNode.contains(event.target)) {
      this.hide();
    }
  };

  isDescendantOfMagicElement(element) {
    // Check if an element is a descendant of any magic elements. "magic" elements are any special cases or
    // 3rd party widgets nested within the menu. Currently the 3rd party date picker adds itself to the body
    // elements, so we want to check for that so we don't hide menus if the date picker is clicked.

    let isDescendantOfMagicElement = false;
    let iter = element;

    while (iter) {
      if (iter.className && iter.className.indexOf && iter.className.indexOf('react-datepicker') !== -1) {
        isDescendantOfMagicElement = true;
        break;
      }

      if (iter.id && iter.id.indexOf && iter.id.indexOf('react-select') !== -1) {
        isDescendantOfMagicElement = true;
        break;
      }

      iter = iter.parentNode;
    }

    return isDescendantOfMagicElement;
  }

  handlePositionChange = (metrics) => {
    this.setState({ metrics });
  };

  addEvents() {
    window.addEventListener('click', this.handleWindowClick, true);

    if (this._container) {
      this._sizeDetector.listenTo(this._container, this.handleResize);
    }
  }

  removeEvents() {
    window.removeEventListener('click', this.handleWindowClick, true);

    if (this._container) {
      this._sizeDetector.removeAllListeners(this._container);
    }
  }

  hide() {
    if (this.props.onHide) {
      this.props.onHide(this);
    }
  }

  bindTether = (node) => {
    this._tether = node;
  };

  bindContainer = (node) => {
    this._container = node;
  };

  bindContent = (node) => {
    this._content = node;
  };
}

const styles = cssInJS({
  container: {
    textAlign: 'left',
    zIndex: 2, // on top of leaflet controls
    boxSizing: 'border-box',
    fontWeight: 'normal',
  },

  visualStyles: {
    borderRadius: 5,
    border: '1px solid #ececec',
    boxShadow: '0 1px 12px 0 rgba(0,0,0,0.2)',
    display: 'flex',
    flexDirection: 'column',
    minWidth: 100,

    backgroundColor: '#fff',
    boxSizing: 'border-box',
    overflowY: 'auto',
  },

  menuItem: {
    color: '#41403b',
    display: 'flex',
    cursor: 'pointer',
    alignItems: 'center',
    fontSize: 13,
    padding: '5px 15px',
    margin: '2px 0',

    ':hover': {
      background: '#f4f4f4',
      color: '#41403b',
    },
  },

  menuTitle: {
    background: '#fff',
    paddingTop: 3,
    paddingBottom: 8,
    borderBottom: '1px solid #eee',
    cursor: 'default',
    pointerEvents: 'none',
  },
});

Menu.styles = styles;

export default withShow(Menu);
